<template>
  <div class="ad-banner" v-if="!isPremiumUser">
    <h3>Publicidad</h3>
    <div class="ad-content">
      <!-- Anuncio de AdSense -->
      <ins class="adsbygoogle"
          style="display:block; width: 100%; height: 100px;"
          data-ad-client="ca-pub-1510186530311664"
          :data-ad-slot="adSlot"
          data-ad-format="auto"
          data-full-width-responsive="true"></ins>
    </div>
  </div>
  
  <!-- Opcional: Mostrar mensaje para usuarios premium -->
  <div v-else class="premium-message">
    <p>🎉 Disfrutando de experiencia sin publicidad</p>
  </div>
</template>

<script>
export default {
  name: 'AdBanner',
  props: {
    adSlot: {
      type: String,
      required: true,
      default: '1234567890' // Reemplaza con tu slot real
    },
    isPremiumUser: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.loadAd();
  },
  methods: {
    loadAd() {
      // Esperar a que el DOM esté listo y cargar el anuncio
      this.$nextTick(() => {
        if (!this.isPremiumUser && window.adsbygoogle) {
          try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          } catch (error) {
            console.warn('Error loading AdSense ad:', error);
          }
        }
      });
    }
  },
  watch: {
    // Recargar anuncio si cambia el estado premium
    isPremiumUser(newVal) {
      if (!newVal) {
        this.loadAd();
      }
    }
  }
}
</script>

<style scoped>

:root {
  --bg-primary: #121212;
  --bg-secondary: #1e1e1e;
  --bg-tertiary: #2d2d2d;
  --text-primary: #e0e0e0;
  --text-secondary: #a0a0a0;
  --accent-primary: #bb86fc;
  --accent-secondary: #03dac6;
  --accent-tertiary: #cf6679;
  --border-color: #383838;
  --card-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

[data-theme="light"] {
  --bg-primary: #f5f5f5;
  --bg-secondary: #ffffff;
  --bg-tertiary: #f0f0f0;
  --text-primary: #333333;
  --text-secondary: #666666;
  --accent-primary: #6200ee;
  --accent-secondary: #018786;
  --accent-tertiary: #b00020;
  --border-color: #e0e0e0;
  --card-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}


.ad-banner {
  margin-top: 30px;
  padding: 15px;
  border: 1px dashed var(--border-color);
  border-radius: 8px;
  text-align: center;
  background-color:  var(--bg-primary);
}

.ad-content {
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.premium-message {
  margin-top: 30px;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  background-color: var(--bg-primary);
  color: #2e7d32;
  border: 1px solid var(--border-color);
}

/* Responsive design para anuncios */
@media (max-width: 768px) {
  .ad-content {
    min-height: 80px;
  }
}

@media (max-width: 480px) {
  .ad-banner {
    padding: 10px;
    margin-top: 20px;
  }
  
  .ad-content {
    min-height: 60px;
  }
}
</style>